<div class="container-fluid" style="background-color: #333333; height: 100%; position: relative; overflow-x: hidden">
	<!-- Title and Price -->

	<!-- FOR en SHOW close icon on right -->
	<ng-container *ngIf="localeService.lang ==='en'">
		<button
			*ngIf="viewport.type !=='mobile'"
			mat-fab
			(click)="onClose()"
			class="mat-elevation-z0"
			style="
				background-color: #757575;
				color: #cccccc;
				width: 30px;
				height: 30px;
				position: absolute;
				top: 24px;
				right: 12px;
				z-index: 2;
				border-radius: 100px;
			"
		>
			<mat-icon style="margin-top: -20px; font-size: 18px; margin-left: 4px">close</mat-icon>
		</button>

		<button
			*ngIf="viewport.type ==='mobile'"
			mat-fab
			(click)="onClose()"
			class="mat-elevation-z0"
			style="
				background-color: #757575;
				color: #cccccc;
				width: 30px;
				height: 30px;
				position: absolute;
				top: 24px;
				left: 12px;
				z-index: 2;
				border-radius: 100px;
			"
		>
			<mat-icon style="margin-top: -20px; font-size: 18px; margin-left: 4px">close</mat-icon>
		</button>
	</ng-container>

	<!-- FOR ku,ar SHOW close icon on left -->
	<ng-container *ngIf="localeService.lang !=='en'">
		<button
			*ngIf="viewport.type !=='mobile'"
			mat-fab
			(click)="onClose()"
			class="mat-elevation-z0"
			style="
				background-color: #757575;
				color: #cccccc;
				width: 30px;
				height: 30px;
				position: absolute;
				top: 24px;
				left: 12px;
				z-index: 2;
				border-radius: 100px;
			"
		>
			<mat-icon style="margin-top: -20px; font-size: 18px; margin-left: 4px">close</mat-icon>
		</button>

		<button
			*ngIf="viewport.type ==='mobile'"
			mat-fab
			(click)="onClose()"
			class="mat-elevation-z0"
			style="
				background-color: #757575;
				color: #cccccc;
				width: 30px;
				height: 30px;
				position: absolute;
				top: 24px;
				right: 12px;
				z-index: 2;
				border-radius: 100px;
			"
		>
			<mat-icon style="margin-top: -20px; font-size: 18px; margin-left: 4px">close</mat-icon>
		</button>
	</ng-container>

	<div class="row d-flex justify-content-center" [attr.dir]="localeService.lang === 'en'  ? 'ltr' : 'rtl'">
		<div
			class="col-sm-12 mt-4"
			[ngStyle]="{'margin-inline-start' : viewport.type === 'mobile' ? '5rem' : '0' }"
			[ngClass]="{'col-md-6' : data.ad.seller?.contactTypeWhatsapp === '0' ,'col-md-8' : data.ad.seller?.contactTypeWhatsapp === '1'}"
		>
			<p class="mb-0 fg-white fs-14px">{{data.ad?.title}} {{localeService.translations['n726']}} {{data.ad?.location}}</p>
			<p class="fg-purple fs-14pxs fw-600">&#36; {{data.ad?.price}}</p>
		</div>
	</div>
	<div class="row justify-content-center">
		<div class="col-12">
			<ngb-carousel
				*ngIf="data['images']"
				[ngClass]="{ 'no-indicators': data['images'].length == 1 }"
				activeId="{{ data['slideID'] }}"
				(slide)="onChange($event)"
				style="height: 62vh"
				cdkFocusInitial
			>
				<ng-template ngbSlide *ngFor="let image of data['images']; let i = index" id="{{ i }}">
					<div style="height: 62vh; display: flex; align-items: center; justify-content: center; cursor: default">
						<img [src]="image['name']" style="height: 62vh; width: 100%; object-fit: contain" />
					</div>
				</ng-template>
			</ngb-carousel>
		</div>
	</div>
	<div class="row d-flex justify-content-center" [attr.dir]="localeService.lang === 'en' ? 'ltr' : 'rtl'">
		<span class="fg-white fs-14px my-2 text-center">{{ currentSlideID + 1 }} / {{ data['images'].length }}</span>

		<div class="col-md-6 col" *ngIf="data.ad.sold === '0'">
			<app-button
				class="call"
				style="display: block; width: 100%"
				customClass="w-100"
				[label]="data.ad?.phone | maskPhone : toggleFullPhoneNumber"
				svgIcon="phone"
				[isStopPropagation]="true"
				(clicked)="onCall(data.ad)"
			></app-button>
		</div>

		<div
			class="col-2 bg-lightest-grey d-flex justify-content-center ad-item-chats"
			[ngClass]="{'me-2' : localeService.lang === 'en' , 'ms-2' : localeService.lang !== 'en'}"
			*ngIf="data.ad.sold === '0' && data.ad.seller?.contactTypeWhatsapp === '1' "
		>
			<app-button
				class="icon"
				svgIcon="whatsapp-2"
				[btnType]="buttonType.ICON"
				[isStopPropagation]="true"
				(clicked)="onCallPlatform(data.ad)"
			></app-button>
		</div>
	</div>
</div>
